// extracted by mini-css-extract-plugin
module.exports = {"customBorder":"productcard-module--customBorder--tQGip"};